import { Injectable } from '@angular/core';
import { from, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { get, put } from 'aws-amplify/api';
import { IAppVersion } from 'src/app/models/IAppVersion';
@Injectable({ providedIn: 'root' })
export class AppVersionService {
  private async readJson<T>(op: { response: Promise<{ body: { json(): Promise<any> } }> }): Promise<T> {
    const r = await op.response;
    return (await r.body.json()) as T;
  }
  public getAppVersion(): Observable<IAppVersion[]> {
    const op = get({
      apiName: 'portal',
      path: 'appVersion',
    });
    return from(this.readJson<IAppVersion[]>(op)).pipe(
      catchError((error) => throwError(() => error)),
      map((data: IAppVersion[]) => data as IAppVersion[])
    );
  }
  public updateAppVersion(data: IAppVersion): Observable<IAppVersion> {
    const body = JSON.parse(JSON.stringify(data)) as Record<string, any>;
    const op = put({
      apiName: 'portal',
      path: 'appVersion',
      options: { body },
    });
    return from(this.readJson<IAppVersion>(op)).pipe(
      catchError((error) => throwError(() => error)),
      map((res: IAppVersion) => res as IAppVersion)
    );
  }
}